import { createFileRoute } from '@tanstack/react-router'
import ProjectAnalysesPage from '@/spa/pages/projects/ProjectAnalysesPage'
import { routeErrorComponent } from '../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/analyses')({
  component: ProjectAnalysesPage,
  errorComponent: routeErrorComponent,
})
